export const getStatusColor = (status: string) => {
  switch (status) {
    case "rejected":
      return "#fff";
    case "approved":
      return "#fff";
    case "pending":
      return "#fff";
    default:
      return "gray";
  }
};


export const getBgColor = (status: string) => {
    switch (status) {
      case "rejected":
        return "rgba(255, 99, 132, 0.8)";
      case "approved":
        return "rgba(77, 182, 172, 0.8)";
      case "pending":
        return "rgba(255, 206, 86, 0.8)";
      case "exception":
        return "rgba(255, 99, 132, 0.8)";
      case "posted":
        return "rgba(77, 182, 172, 0.8)";
      case "pending":
        return "rgba(255, 206, 86, 0.8)";
      case "total":
        return "#606e8d";
      default:
        return "gray";
    }
};

export const generateChartData = (chartData : any) => {
  return {
    labels: chartData?.map((item: any) => item.status.charAt(0).toUpperCase() + item.status.slice(1).toLowerCase()),
    datasets: [
      {
        data: chartData?.map((item: any) => item.count),
        backgroundColor: chartData?.map((item: any) => getBgColor(item.status)), // Use getBgColor function here
        borderColor: chartData?.map((item: any) => getStatusColor(item.status)), // Border color remains same
        borderWidth: 2,
      }
    ],
  };
}

export const filterEmptyKeys = (obj: Record<string, any>): Record<string, any> => {
  const filteredObj: Record<string, any> = {};
  for (const key in obj) {
    if (key.trim() !== "") {
      if (typeof obj[key] === "object") {
        filteredObj[key] = filterEmptyKeys(obj[key]);
      } else {
        filteredObj[key] = obj[key];
      }
    }
  }
  return filteredObj;
};